module.exports = __webpack_public_path__ + "static/media/dsr_journey3.a1e54153.svg";